import { Box, Paper, styled } from '@mui/material';
import { LoadingPane } from '~/components/loading-pane';

export const CardPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderLeft: '5px solid',
  borderColor: theme.palette.primary.main,
}));

export const LoadingSpinner = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 400,
});

export const TabsLoadingPane = styled(LoadingPane)({
  height: 'auto',
  minHeight: 400,
});

export const ListTabHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const SectionStack = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const TabRoot = styled(SectionStack)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
}));
